// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/prognosis.scss
// module id = 454
// module chunks = 0